module.exports = __webpack_public_path__ + "static/media/No data.cb0f07bd.svg";